import { CUSTOM_TV, TV_SKUS, tvChoice, type TvChoice } from './sku.ts';

export function mountTvPicker(container: HTMLElement, onChange: (choice: TvChoice) => void = () => undefined): () => TvChoice {
  const initial: TvChoice = TV_SKUS.find((item) => item.id === 'lg-oled65c4pua') ?? TV_SKUS[0]!;
  container.innerHTML = `
    <fieldset class="tv-ruler">
      <legend>TV ruler</legend>
      <label for="tv-sku">Visible panel model</label>
      <select id="tv-sku">
        ${TV_SKUS.map((item) => `<option value="${item.id}">${item.brand} ${item.model} · ${item.viewableDiagonalIn.toFixed(1)} in</option>`).join('')}
        <option value="custom">Custom active picture</option>
      </select>
      <div class="custom-tv" data-custom-tv hidden>
        <label>Width <span><input data-tv-width type="number" min="0.2" max="8" step="0.001" value="${CUSTOM_TV.panelWidthM.toFixed(4)}" /> m</span></label>
        <label>Height <span><input data-tv-height type="number" min="0.1" max="5" step="0.001" value="${CUSTOM_TV.panelHeightM.toFixed(4)}" /> m</span></label>
      </div>
      <output data-tv-size></output>
      <p>The active picture is the metric ruler for the camera and room—not the bezel.</p>
    </fieldset>`;

  const select = container.querySelector<HTMLSelectElement>('#tv-sku')!;
  const custom = container.querySelector<HTMLElement>('[data-custom-tv]')!;
  const width = container.querySelector<HTMLInputElement>('[data-tv-width]')!;
  const height = container.querySelector<HTMLInputElement>('[data-tv-height]')!;
  const output = container.querySelector<HTMLOutputElement>('[data-tv-size]')!;
  select.value = initial.id;
  width.value = initial.panelWidthM.toFixed(4);
  height.value = initial.panelHeightM.toFixed(4);

  let current: TvChoice = initial;
  const update = (): void => {
    custom.hidden = select.value !== 'custom';
    current = tvChoice(select.value, Number(width.value), Number(height.value));
    output.value = `${current.panelWidthM.toFixed(4)} × ${current.panelHeightM.toFixed(4)} m`;
    onChange(current);
  };
  select.addEventListener('change', update);
  width.addEventListener('input', update);
  height.addEventListener('input', update);
  update();
  return () => current;
}
